module.exports = __webpack_public_path__ + "img/icon1-5.f9d83ebb.png";